import {useEffect, useState} from 'react'
import {DebounceInput} from 'react-debounce-input'
import {useIntl} from 'react-intl'

import FilterDrawer from '../component/List/FilterDrawer'

import {useGetMembersPurchased} from '../context/useQuery'
import {useMember} from '../hook'

import {useParams} from 'react-router-dom'
import {useItem} from 'src/feature/items/hook'
import MembersByItemList from '../component/List/MembersByItemList'

export default function MembersByItem({isMembershipProduct}: {isMembershipProduct?: boolean}) {
  const intl = useIntl()
  const {detail} = useItem()

  const {itemId} = useParams()
  const {
    listPurchaseFilter: listFilter,
    listPurchaseFilterSet: listFilterSet,
    listPurchase,
  } = useMember()
  const isMemberShipProduct = detail?.isSubscriptionPackage

  const {isLoading, isFetching} = useGetMembersPurchased(itemId || '', isMemberShipProduct ? 2 : 1)
  const [search, setSearch] = useState('')
  const [open, setOpen] = useState(false)
  const [badges, setBadges] = useState<{key: string; value: string}[]>([{key: 'search', value: ''}])

  useEffect(() => {
    if (listFilter.filterList.length > 0) {
      const searchFilter = listFilter.filterList.find((x) => x.key === 'fllNm')

      if (searchFilter) {
        setSearch(searchFilter.value[0])
        setBadges([{key: 'search', value: searchFilter.value[0]}])
      }
    }
  }, [])

  if (!itemId) {
    return <div>Product not found</div>
  }

  return (
    <>
      {/*       <Component.Breadcrumb currentPage={intl.formatMessage({id: 'MEMBER_PLURAL'})} />
       */}
      <div className='card'>
        <div className='card-header border-0 pt-6'>
          <div className='card-title'>
            <div className='d-flex align-items-center position-relative my-1'>
              <i className='ki-outline ki-magnifier fs-3 position-absolute ms-5'></i>
              <DebounceInput
                debounceTimeout={500}
                type='text'
                className='form-control form-control-solid w-600px ps-13'
                placeholder='Search by member name and surname'
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value)
                  listFilterSet({
                    ...listFilter,
                    paging: {
                      ...listFilter.paging,
                      currentPageNumber: 1,
                    },
                    filterList: [
                      {
                        key: 'fllNm',
                        operator: 14,
                        logicalOp: 2,
                        value: [e.target.value],
                        childFilters: [],
                      },
                    ],
                  })

                  let newBadges = [...badges]
                  newBadges[0] = {key: 'search', value: e.target.value}

                  setBadges(newBadges)
                }}
              />
            </div>
          </div>
          <div className='card-toolbar'>
            <div className='d-flex justify-content-end' data-kt-customer-table-toolbar='base'>
              <div className='d-flex align-items-center gap-2 gap-lg-3'>
                <button
                  onClick={() => setOpen(!open)}
                  className='btn btn-light'
                  data-bs-toggle='tooltip'
                  data-bs-placement='left'
                  data-bs-dismiss='click'
                  data-bs-trigger='hover'
                  id='kt_filter_toggle'
                >
                  <i className='bi bi-sliders fs-4 me-4'></i>
                  {intl.formatMessage({id: 'GLOBAL.FILTER'})}
                </button>
                <FilterDrawer
                  open={open}
                  keyVal='crtdOn'
                  setOpen={setOpen}
                  search={search}
                  label='Search by Start Date and End Date'
                  searchLabel='Search by member name and surname'
                  setSearch={setSearch}
                  setFilter={(value: any) => {
                    listFilterSet({
                      ...listFilter,
                      filterList: value,
                      paging: {
                        ...listFilter.paging,
                        currentPageNumber: 1,
                      },
                    })
                  }}
                  badges={badges}
                  setBadges={setBadges}
                />
              </div>
            </div>
          </div>
        </div>
        <div className='card-body pt-10'>
          <div>
            <h3 className='fw-bold py-5'>Members Who Purchased {listPurchase?.purchasedName}</h3>
          </div>
          <MembersByItemList
            isMemberShipProduct={isMemberShipProduct}
            loading={isLoading || isFetching}
            itemId={itemId}
          />
        </div>
      </div>
    </>
  )
}
